import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoMonogram = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 5.75C8.45178 5.75 11.25 8.54822 11.25 12C11.25 15.4518 8.45178 18.25 5 18.25H3C2.66848 18.25 2.35063 18.1182 2.11621 17.8838C1.88179 17.6494 1.75 17.3315 1.75 17V7C1.75 6.30964 2.30964 5.75 3 5.75H5ZM17.207 5.75C18.3902 5.75 19.3544 6.39554 19.9795 7.14062C20.6024 7.88314 21.0234 8.87653 21.0234 9.86816C21.0234 11.2598 20.2234 12.4005 19.0957 13.0088L21.9785 18H19.0908L16.4854 13.4873H14.75V18H12.25V7C12.25 6.30964 12.8096 5.75 13.5 5.75H17.207ZM4.25 15.75H5C7.07107 15.75 8.75 14.0711 8.75 12C8.75 9.92893 7.07107 8.25 5 8.25H4.25V15.75ZM14.75 10.9873H17.207C18.0305 10.9873 18.5234 10.3932 18.5234 9.86816C18.5234 9.55194 18.3702 9.11157 18.0645 8.74707C17.7607 8.38496 17.4413 8.25 17.207 8.25H14.75V10.9873Z",
		fill: "currentColor"
	})
});
export default SvgLogoMonogram;
